{
  "R": [48, 48, 64, 70, 65, 25, 132, 195, 244, 254, 218, 122],
  "G": [18, 18, 64, 107, 150, 226, 255, 241, 199, 158, 57, 4],
  "B": [59, 59, 162, 227, 255, 187, 81, 52, 58, 47, 7, 3],
  "A": [0, 22, 26, 30, 34, 43, 52, 57, 63, 67, 77, 86],
  "I": [0, 1, 16, 32, 49, 83, 118, 140, 164, 181, 219, 255]
}
